<template>
    <section class="recharge-payment-view">
        <HeaderComponent :title="'Pagamento com Cartão'" />
        <div class="totalValue">
            <h1>Valor Total</h1>
            <h1 v-if="isInvoiceMode" v-text="formatValue(invoiceTotalValue)"></h1>
            <h1 v-else v-text="formatValue(totalRechargeValue)"></h1>
        </div>

        <div class="card-details">
            <div class="flag">
                <label for="flag" class="required">Bandeira</label>

                <div class="flagSelect">
                    <select name="flag" id="" v-model="selectedFlag">
                        <option v-for="(opt, key) in rechargePaymentInfra.flags" :key="key" :value="opt" v-text="opt"></option>
                    </select>
                    <div v-if="selectedFlag">
                        <img :src="getCardFlag(selectedFlag)">
                    </div>
                </div>

            </div>
            <InputContainer :inputs="rechargePaymentInfra.inputs" ref="inputContainer"/>
            <div class="button-cont">
                <ButtonCenter :button="confirmButton" @click="pay"/>
            </div>
        </div>

        <ModalInfo :modalOpen="confirmationModalOpen" @closeModal="finishRecharge" />
        <ScreenLoader :isLoading="isLoading" />
    </section>
</template>

<script>
import InputContainer from '@/components/inputs/InputContainer.vue'
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import ButtonCenter from '@/components/buttons/center/ButtonCenter.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import { showAlertNotification } from '@/libs/Util'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

import { doCardRecharge, doCardInvoicePayment } from '@/components/controllers/CardRechargeController.js'
import { updateSonsAfterRecharge } from '@/components/controllers/RechargeController.js'

export default {
    name: 'RechargePaymentView',
    components: {
        HeaderComponent,
        InputContainer,
        ButtonCenter,
        ModalInfo,
        ScreenLoader
    },
    data () {
        return {
            inputs: [
                {
                    display: 'Numero do cartão',
                    placeHolder: 'Nº do cartão',
                    type: 'text',
                    required: true,
                    format: 'cardNumber'
                },
                {
                    display: 'Data de Validade',
                    placeHolder: 'Validade',
                    type: 'text',
                    required: true,
                    half: true,
                    format: 'cardDate'
                },
                {
                    display: 'Cód. de Segurança',
                    placeHolder: 'CVV',
                    type: 'text',
                    required: true,
                    half: true,
                    format: 'cardCVV'
                }
            ],
            confirmButton: {
                display: 'Confirmar',
                fill: true,
                action: this.pay
            },
            selectedFlag: '',
            confirmationModalOpen: false,
            isLoading: false
        }
    },
    computed: {
        ...mapGetters(['rechargePaymentInfra', 'totalRechargeValue', 'rechargeValues', 'rechargePaymentData',
            'rechargeMode', 'isInvoiceMode', 'invoiceTotalValue', 'idBoletos'])
    },
    methods: {
        ...mapActions(['showModalInfo', 'storeSons']),
        formatValue (value) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        pay () {
            const inputContainer = this.$refs.inputContainer
            const inputValues = inputContainer.getValues()

            const cardNumber = inputValues[0].value.replace(/\s/g, '') // remove espaços
            const cardHolder = inputValues[1].value
            const cardDate = inputValues[2].value
            const cardCVV = inputValues[3].value
            this.selectedFlag = this.selectedFlag.toUpperCase()
            const mode = this.rechargeMode

            const valid = this.verifyInputs(cardNumber, cardDate, cardCVV, this.selectedFlag)
            if (valid) {
                this.isLoading = true

                if (this.isInvoiceMode) {
                    doCardInvoicePayment(this.invoiceTotalValue, this.selectedFlag, cardDate, cardNumber, cardCVV, cardHolder, mode, this.idBoletos).then((res) => {
                        this.isLoading = false
                        if (res.sucesso) {
                            this.confirmationModalOpen = true
                            this.showModalInfo({
                                type: 'default',
                                text: res.data.message,
                                icon: 'fa-solid fa-circle-check'
                            })
                        }
                    })
                } else {
                    doCardRecharge(this.totalRechargeValue, this.selectedFlag, cardDate, cardNumber, cardCVV, cardHolder, this.rechargeValues, mode).then((res) => {
                        this.isLoading = false
                        if (res.sucesso) {
                            this.storeSons([])
                            this.confirmationModalOpen = true
                            this.showModalInfo({
                                type: 'default',
                                text: res.data.message,
                                icon: 'fa-solid fa-circle-check'
                            })
                        }
                    })
                }
            }
        },
        verifyInputs (cardNumber, cardDate, cardCVV, flag) {
            // verificar se os campos estão preenchidos verificando o value
            if (!cardNumber || !cardDate || !cardCVV || !flag) {
                showAlertNotification({
                    title: '',
                    text: 'Preencha todos os campos.'
                })
                return false
            }

            // verificar se os campos estão no formato correto
            if (cardNumber.length !== 16 || cardDate.length !== 5 || (cardCVV.length !== 3 && cardCVV.length !== 4)) {
                showAlertNotification({
                    title: '',
                    text: 'Preencha os campos corretamente.'
                })
                return false
            }

            // verificar data de validade
            const month = moment().format('MM')
            const year = moment().format('YY')
            const cardMonth = cardDate.split('/')[0]
            const cardYear = cardDate.split('/')[1]
            if (cardYear < year || (cardYear === year && cardMonth < month) || cardMonth > 12 || cardMonth < 1) {
                showAlertNotification({
                    title: '',
                    text: 'Cartão vencido ou data inválida.'
                })
                return false
            }

            return true
        },
        getCardFlag (flag) {
            if (flag && flag.length > 2) {
                try {
                    return require('@/assets/default/icons/cardflags/' + flag.toLocaleLowerCase() + '.svg')
                } catch (e) {
                    return require('@/assets/default/icons/cardflags/generic-clean.svg')
                }
            }
            return ''
        },
        finishRecharge () {
            // atualiza o saldo dos filhos
            updateSonsAfterRecharge()

            this.confirmationModalOpen = false
            this.$router.push('/home')
        }
    },
    mounted () {
    }
}
</script>

<style lang="less" scoped>
.totalValue {
    display: flex;
    justify-content: space-between;
    margin: 30px 0px;
    h1 {
        font-weight: 600;
    }
}

.card-details {
    height: calc(100vh - 127px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 2px;

    &::-webkit-scrollbar {
        display: none;
    }
}

.flag {
    margin-bottom: 15px;
    font-size: 16px;
    display: block;
    width: calc(100%);

    label {
        display: block;
        margin-bottom: 5px;

        &.required:after {
            content: '*';
            color: red;
            margin-left: 5px;
        }
    }

    select {
        width: calc(100%);
        padding: 15px;
        font-size: 16px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 7px;
        margin-top: 10px;
    }

}

// class flag with image inside
.flag:has(img) {
    margin-bottom: 15px;
    font-size: 16px;
    width: calc(100%);
    display: flex;
    flex-direction: column;

    .flagSelect {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        width: 100%;

        select {
            width: calc(100% - 80px);
            padding: 15px;
            font-size: 16px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 7px;
            margin-top: 10px;
        }

        img {
            width: 70px;
            height: 50px;
            border-radius: 10px;
        }
    }
}

.button-cont {
    margin-top: 30px;

    button {
        width: calc(100% - 30%);
    }
}

</style>
